const enum JwtScope {
  WEBAPP = 'webapp'
}

export default JwtScope;
